import * as React from 'react'

function SvgCookie(props) {
    return (
        <svg viewBox='0 0 511.999 511.999' {...props}>
            <path
                d='M501.783 235.237c-29.7-10.499-49.799-38.699-49.799-70.199.601-5.101-1.8-9.3-5.7-12.9-3.3-2.701-8.399-3.9-12.599-3.301-25.201 3.6-49.2-3.6-67.5-18.3s-31.201-36.899-33.3-62.699c-.3-4.501-3.001-8.701-6.901-11.4-3.9-2.401-8.699-3.001-13.2-1.201-40.8 14.7-79.2-11.1-94.499-46.199-3.001-6.601-9.901-10.201-17.1-8.699-57.601 12.9-109.401 49.06-144.8 94.661-81.899 105.3-73.5 250.201 18.3 342.301 99.901 99.598 261 99.598 360.601 0 46.199-46.201 76.7-112.063 76.7-182.262-.603-9.901-.903-16.5-10.203-19.802z'
                fill='#fea832'
            />
            <path
                d='M511.983 255.038c0 70.199-30.5 136.061-76.7 182.262-99.6 99.598-260.7 99.598-360.601 0l291.501-306.763c18.3 14.7 42.299 21.899 67.5 18.3 4.2-.599 9.3.601 12.599 3.301 3.9 3.6 6.301 7.798 5.7 12.9 0 31.5 20.099 59.7 49.799 70.199 9.302 3.302 9.602 9.901 10.202 19.801z'
                fill='#fe9923'
            />
            <path
                d='M193.484 312.499c-7.5-6.599-17.701-10.499-28.5-10.499-24.901 0-45 20.099-45 45 0 11.7 4.501 22.2 11.7 30 8.099 9.3 20.099 15 33.3 15 24.901 0 45-20.101 45-45-.001-14.101-6.301-26.4-16.5-34.501z'
                fill='#994c0f'
            />
            <g fill='#713708'>
                <path d='M314.983 302c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.185 45-45 45zM299.983 422c-16.538 0-30-13.462-30-30s13.462-30 30-30 30 13.462 30 30-13.462 30-30 30z' />
            </g>
            <path
                d='M179.983 212c-16.538 0-30-13.462-30-30s13.462-30 30-30 30 13.462 30 30-13.462 30-30 30z'
                fill='#994c0f'
            />
            <circle cx={404.238} cy={318.13} r={15} fill='#713708' />
            <circle cx={104.228} cy={258.13} r={15} fill='#994c0f' />
            <path
                d='M209.983 347c0 24.899-20.099 45-45 45-13.2 0-25.201-5.7-33.3-15l61.8-64.501c10.2 8.101 16.5 20.4 16.5 34.501z'
                fill='#713708'
            />
        </svg>
    )
}

export default SvgCookie
